import './App.css';
import hamburger from './HamburgerMenu.svg'
import city from './MostLivableCity.jpg'
import React, { useEffect, useState } from 'react';

const styles = {
  homeContainer: {
    alignItems: 'stretch',
    flex: 1
  },
  menuIcon: {
    width: '80px',
    height: '80px',
    position: 'absolute',
    top: 0,
    right: 0,
    margin: 20
  },
  homeImageMobile: {
    width: '100%',
    height: 'auto',
    marginTop: 25
  },
}
console.log(window.innerWidth)
function Home(props) {
  return (
    <div className="App">
      <div style={styles.homeContainer}>
        <a href='/menu'>
          <img src={hamburger}
            style={styles.menuIcon}
          />
        </a>
      </div>
      <img src={city}
        style={styles.homeImageMobile}
      />
    </div>
  );
}

export default Home;
